import AddIcon from "@mui/icons-material/Add";
import { Box, Container, Fab } from "@mui/material";
import FilterableSkuList, {
  SkuListFilter,
} from "components/FilterableSkuList";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { Link } from "react-router-dom";
import contextStore from "stores/contextStore";

const skuListFilters = Object.values(SkuListFilter);

const SkuList = () => {
  const { skuCreateUrl } = useGlobalContext();
  const { organizationId } = contextStore.useState();

  useTitle("Sku List");

  return (
    <Container>
      <Box mb={3} justifyContent="center" display="flex">
        <Link to={skuCreateUrl("-")} style={{ textDecoration: "none" }}>
          <Fab aria-label="add" color="primary">
            <AddIcon />
          </Fab>
        </Link>
      </Box>

      <FilterableSkuList
        organizationId={organizationId}
        filters={skuListFilters}
      />
    </Container>
  );
};

export default SkuList;
